import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";

// Action Types
export const FIREBASE_AI_TASKS_SUCCESS = "FIREBASE_AI_TASKS_SUCCESS";
export const FIREBASE_AI_TASKS_ERROR = "FIREBASE_AI_TASKS_ERROR";

// Thunk Action Creator
export const aiTasksToFirebaseAction = createAsyncThunk(
    "api/Task/aiTasks",
    async (json, { dispatch }) => {

        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.post(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/aiTasks`,
                    {
                        ParentId: json.parentId,
                        TodoTitle: json.todoTitle,
                        SubTaskTitles: json.subTaskTitles,
                        NewTodo: json.newTodo
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else {
                    throw new Error("Error adding AI task to firebase");
                }

                dispatch({
                    type: FIREBASE_AI_TASKS_SUCCESS,
                    payload: response.data,
                });
            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: FIREBASE_AI_TASKS_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }


        }
        catch (error) {
            dispatch({ type: FIREBASE_AI_TASKS_ERROR, payload: error });
            await signOut();
        }



        //)
        //    .then(response => {
        //        dispatch({ type: FIREBASE_AI_TASKS_SUCCESS, payload: response.data });
        //        //dispatch(getLatestTaskList());
        //    })
        //    .catch(error => {
        //        dispatch({ type: FIREBASE_AI_TASKS_ERROR, payload: error });
        //    });
    }
);